let inited = false;
let getMember = () => false;

module.exports = (rule, cb) => {
	getMember = cb;

	if (!inited) {
		rule.pm.handleEvent('@parent ~.Widget', 'inited', (params, widget) => {
			if (!('templateEnv' in widget.options)) {
				widget.options.templateEnv = {};
			}

			if (!('member' in widget.options.templateEnv)) {
				Object.defineProperty(widget.options.templateEnv, 'member', {
					enumerable: true,
					get: () => {
						return getMember();
					}
				})
			}
		}, {
			prefix: 'rule_template_env_member',
			sync: true
		});

		inited = true;
	}
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-access/widget/rules/common/register-member-tplenv.es.js